import {SET_VISIBLE_POSITION} from "../actions/catalog_actions";

const initialState = {
    visible_position: -1,
};

export function catalogReducer(state  = initialState,action) {
    switch (action.type) {
        case SET_VISIBLE_POSITION:{
            return{...state, visible_position: action.payload};
        }
        default:
            return {...state};
    }
}
